module.exports = __webpack_public_path__ + "img/icon_drop.d3d7d022.svg";